import { useState } from 'react';
import { SuccessFilled } from 'iglooicon';
import { useIntl } from 'react-intl';
import EmailVerification from './index';
import './index.less';

export default (platformKey: string) => {
  const { formatMessage } = useIntl();

  const [email, setEmail] = useState<string>('');
  const [emailVerifiSuccess, setEmailVerifiSuccess] = useState<boolean>(false);

  const emailExtra = emailVerifiSuccess
    ? formatMessage({
        id: 'Email has been verified.',
        defaultMessage: 'Email has been verified.',
      })
    : formatMessage({
        id: 'Email need to be verified.',
        defaultMessage: 'Email need to be verified.',
      });

  const emailSuffix = emailVerifiSuccess ? (
    <SuccessFilled className="suffixIcon" />
  ) : null;

  const emailExtraLabel = (
    <EmailVerification
      email={email}
      verifiSuccess={emailVerifiSuccess}
      setVerifiSuccess={setEmailVerifiSuccess}
      platformKey={platformKey}
    />
  );

  const onEmailChange = (e: React.ChangeEvent<HTMLInputElement>) =>
    setEmail(e?.target?.value?.trim() || '');

  return {
    email,
    setEmail,
    emailVerifiSuccess,
    setEmailVerifiSuccess,
    emailExtra,
    emailSuffix,
    emailExtraLabel,
    onEmailChange,
  };
};
